import { Text } from '~components/Typography';
import { useTranslations } from '~i18n/hooks';

export const Copyright = () => {
	const t = useTranslations('SideMenu');

	return (
		<Text size="M" color="semi-transparent">
			{t('menuCopyright')}
		</Text>
	);
};
